import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { getDividendFilteredData, getErrorMessage } from '../../portfolios/utils';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import {
    IsAllow,
    PORTFOLIO_RESPONSE_PAYLOAD,
    SCHEMES_RESPONSE,
} from '../../../../redux-store/types/portfolio';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '../index';
import { CommercialRootPath } from '../routeConfig';
import { getMatchAndUnMatchedFunds } from '../../../../utils/utilityFunctions';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { SWITCH } from '../../../../utils/constants';
import { stpFilters } from '../Switch/utils';
import { STPPaths } from './types';
import { NomineeStatusError, NomineeStatusErrorRef } from '../../../common/NomineeStatusError';

type Props = {
    portfolios: PORTFOLIO_RESPONSE_PAYLOAD;
};

const { dbCommercial, dashboard } = en;

const STPColumns: TableColumn[] = [
    { field: 'folio', headerName: 'Folio', width: 150 },
    {
        field: 'id',
        headerName: 'Scheme Name',
        fullWidth: true,
        valueGetter: ({ row }) => `${row?.schemeName}`,
        width: 350,
    },
    {
        field: 'availableAmount',
        headerName: 'Available Amount',
        valueGetter: ({ row }) => formatAsIndianCurrency(row?.availableAmount),
        width: 225,
    },
    {
        field: 'availableUnits',
        headerName: 'Available Units',
        valueGetter: ({ row }) => row?.availableUnits,
        width: 225,
    },
];

const STP: React.FunctionComponent<Props> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [rowData, setRowData] = useState<SCHEMES_RESPONSE[]>([]);
    const { portfolios } = props;
    const history = useHistory();
    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<SCHEMES_RESPONSE[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns: STPColumns,
        loading,
    });
    const dispath = useDispatch();
    const nomineeErrorRef = useRef<NomineeStatusErrorRef>(null);

    useEffect(() => {
        setLoading(true);
        async function fetchPortfolio() {
            try {
                const res: any = await dispath(getPortfolio());
                const { data }: PORTFOLIO_RESPONSE_PAYLOAD = res.body;
                const schemeOptionsData = getDividendFilteredData(data);
                const _data = getMatchAndUnMatchedFunds(stpFilters, schemeOptionsData, true);
                setRowData(_data);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        fetchPortfolio();
    }, []);

    const handleSubmit = async () => {
        const { amc, isin } = selectedRows[0];
        // if (![IsAllow.YES, 'O'].includes(nomineeStatus.toUpperCase())) {
        //     nomineeErrorRef.current?.showNomineeError();
        // } else {
        history.push(`${CommercialRootPath}${STPPaths.to}`, {
            stpFromScheme: selectedRows[0],
            data: tableRows.filter(
                (row) => !row.isDisabled && row.amc === amc && row.isin !== isin,
            ),
        });
        // }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.stp.heading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <>
                        <h5> {dbCommercial.switch.switchFromInfo}</h5>
                        {!!loading || tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                toolTipTextGetter={({ row }) => getErrorMessage(row, stpFilters)}
                                toolTipEnabled
                                radioGroupsEnabled
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={dbCommercial.switch.errors.noFolios} />
                        )}
                    </>
                    {/* <FaqLink section={SWITCH} /> */}
                </div>
                {/* <NomineeStatusError ref={nomineeErrorRef} /> */}
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                disabled={!selectedRows.length}
                                onClick={handleSubmit}
                            >
                                {dashboard.ChangeDividend.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default STP;
